import React, { useState } from "react";
import { ModalBody } from "reactstrap";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import { LeaveComapany } from "../../../../../redux/team/action";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";

export default function LeaveCompanyModel({ setLeavemodel, companyid }) {
  const [loading, setLoading] = useState(false);
  
  const [showConfirm, setShowConfirm] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  
  const dispatch = useDispatch();

  const handleSubmit = async (isConfirm = 0) => {
    setLoading(true);

    const data = {
      company_id: companyid,
      type: 9,
      ...(isConfirm === 1 && { confirm: 1 }),
    };

    
    const result = await dispatch(LeaveComapany(data));

    setLoading(false);

    if (result?.success) {
      
      setLeavemodel(false);
      setShowConfirm(false);
    } else {
     
      setErrorMessage(result?.message || "Something went wrong.");
      setShowConfirm(true);
    }
  };

  return (
    <>
      <div className="add-task">
        <h6>{showConfirm ? "Action Required" : "Leave Team"}</h6>
        <button
          onClick={() => setLeavemodel((state) => !state)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt="close"
          />
        </button>
      </div>

      <ModalBody>
      
        <p>{showConfirm ? errorMessage : "Are you Sure, You Want to Leave Team?"}</p>
      </ModalBody>

      <div className="modal-footer" style={{ marginTop: 50, columnGap: "30px", flexWrap: "nowrap" }}>
        <button
          disabled={loading}
        
          onClick={() => setLeavemodel((state) => !state)}
          className="btn"
          style={{ background: "#fff", color: "black", border: "2px solid " }}
          type="button"
        >
          Cancel
        </button>
        <button
          disabled={loading}
          onClick={() => handleSubmit(showConfirm ? 1 : 0)}
          className="btn"
          type="button"
        >
          {loading ? (
            <LoginLoaderButton />
          ) : showConfirm ? (
            "Confirm"
          ) : (
            "Yes"
          )}
        </button>
      </div>
    </>
  );
}